// src/services/countries.js
// Detects the active country from the hostname and exposes the catalog
// of sources + UI labels that should be used for that country.

export const COUNTRIES = {
  FR: 'FR',
  IT: 'IT',
};

export function detectCountry() {
  const buildCountry = process.env.VUE_APP_COUNTRY;
  if (buildCountry && COUNTRIES[buildCountry.toUpperCase()]) {
    return COUNTRIES[buildCountry.toUpperCase()];
  }
  if (typeof window === 'undefined' || !window.location) {
    return COUNTRIES.FR;
  }
  const host = window.location.hostname;
  if (host.startsWith('it.') || host.startsWith('it-')) {
    return COUNTRIES.IT;
  }
  return COUNTRIES.FR;
}

export const SOURCES_BY_COUNTRY = {
  FR: [
    { id: 'juritext', title: 'Jurisprudence française', selected: true, category: 'principal' },
    { id: 'legiarti', title: 'Codes et lois françaises', selected: true, category: 'principal' },
    { id: 'euritext', title: 'Jurisprudence européenne', selected: true, category: 'principal' },
    { id: 'reglements', title: 'Directives & Règlements européens', selected: true, category: 'principal' },
    { id: 'bofip', title: 'Doctrine fiscale (BOFIP)', selected: true, category: 'secondary' },
    { id: 'concurrence', title: 'Autorité de la concurrence', selected: true, category: 'secondary' },
    { id: 'inpi', title: 'INPI (marques, brevets)', selected: true, category: 'secondary' },
    { id: 'cnil', title: 'CNIL (données personnelles, sanctions)', selected: true, category: 'secondary' },
    { id: 'boss', title: 'BOSS (Sécurité sociale, cotisations, exonérations)', selected: true, category: 'secondary' },
    { id: 'acpr', title: 'ACPR (régulation bancaire, assurance)', selected: true, category: 'secondary' },
    { id: 'amf', title: "AMF (marchés financiers, protection des investisseurs)", selected: true, category: 'secondary' },
    { id: 'cnn', title: 'Conventions collectives', selected: true, category: 'secondary' },
    { id: 'convbi', title: 'Conventions fiscales internationales', selected: true, category: 'secondary' },
    { id: 'infofi', title: 'Informations financières (sociétés cotées: rapports, communiqués...)', selected: true, category: 'secondary' },
    { id: 'bodacc', title: 'BODACC (annonces commerciales)', selected: true, category: 'secondary' },
    { id: 'eccomp', title: 'Commission Européenne - Concurrence', selected: true, category: 'secondary' },
    { id: 'upc', title: 'Juridiction unifiée du brevet (UPC)', selected: true, category: 'secondary' },
    { id: 'edpb', title: 'European Data Protection Board (EDPB) — RGPD', selected: true, category: 'secondary' },
  ],
  IT: [
    { id: 'agcm', title: 'Autorità Garante della Concorrenza e del Mercato (AGCM)', selected: true, category: 'principal' },
    { id: 'giustizia_amministrativa', title: 'Giustizia amministrativa (Consiglio di Stato, TAR)', selected: true, category: 'principal' },
    { id: 'jurisprudence_europe_italy', title: 'Giurisprudenza europea in italiano (CGUE, Tribunale UE)', selected: true, category: 'principal' },
    { id: 'eurlex_italy', title: 'Regolamenti e Direttive UE', selected: true, category: 'principal' },
    { id: 'eccomp', title: 'Commissione Europea — Decisioni concorrenza (UE)', selected: true, category: 'principal' },
  ],
};

export function getSources(country = detectCountry()) {
  return SOURCES_BY_COUNTRY[country] || SOURCES_BY_COUNTRY.FR;
}
